export default __webpack_public_path__ + "static/media/maple.8749534f.webp";